import { render, staticRenderFns } from "./Modal-content.vue?vue&type=template&id=6a6413ea&scoped=true&lang=pug"
import script from "./Modal-content.vue?vue&type=script&lang=js"
export * from "./Modal-content.vue?vue&type=script&lang=js"
import style0 from "./Modal-content.vue?vue&type=style&index=0&id=6a6413ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6413ea",
  null
  
)

export default component.exports